var _style, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 245.3 245.3",
    viewBox: "0 0 245.3 245.3",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.75;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:#232C85;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 122.7,
    cy: 122.7,
    r: 122.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.7,18c57.7,0,104.7,47,104.7,104.7s-47,104.7-104.7,104.7S18,180.4,18,122.7S65,18,122.7,18 M122.7,0   C54.9,0,0,54.9,0,122.7c0,67.7,54.9,122.7,122.7,122.7c67.7,0,122.7-54.9,122.7-122.7C245.3,54.9,190.4,0,122.7,0L122.7,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m83.5 169.7h29.2v-53.9h-29.2v-17.3h51.2v71.3h27.1v17.3h-78.3v-17.4zm26.1-96.1v-4.1c0-6.2 3.8-11.2 14.1-11.2s14.1 5 14.1 11.2v4.1c0 6.2-3.8 11.2-14.1 11.2s-14.1-5.1-14.1-11.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.adc44d04e5db3f1fda77e828a1e8e3eb.svg";
export { ForwardRef as ReactComponent };